function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 10.674l-1.963-2.15-6.64 7.342V0H8.603v15.866l-6.64-7.341L0 10.674 10 21z",
  fill: "#026747",
  fillRule: "evenodd"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMSI+CiAgPHBhdGggZD0iTTIwIDEwLjY3NGwtMS45NjMtMi4xNS02LjY0IDcuMzQyVjBIOC42MDN2MTUuODY2bC02LjY0LTcuMzQxTDAgMTAuNjc0IDEwIDIxeiIgZmlsbD0iIzAyNjc0NyIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";
export { SvgArrowDown as ReactComponent };